import { DeviceType } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import Button from 'components/Button/Button';
import { cn } from 'components/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger
} from 'components/ui/tooltip';

export const ScreenResolutionController: React.FC = () => {
  const {
    previewDeviceLayout,
    previewScreenResolution,
    cyclePreviewScreenResolution
  } = useTemplateStudioState();

  const isDisabled = previewDeviceLayout !== DeviceType.DESKTOP;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={isDisabled}
          onClick={cyclePreviewScreenResolution}
          dataTestId="TemplatesStudio-ScreenResolutionToggle"
          className={cn(
            'w-[56px] px-2 font-medium tabular-nums',
            isDisabled
              ? 'text-neutral-300'
              : 'text-base-sidebarRing hover:bg-neutral-100'
          )}
        >
          {previewScreenResolution}%
        </Button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className="z-[1100]">
          <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
            Screen resolution
          </p>
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
